"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformNotificationApi = exports.SdPlatformNotificationSummaryEmbeddableFields = exports.SdPlatformNotificationEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
var SdPlatformNotificationEmbeddableFields;
(function (SdPlatformNotificationEmbeddableFields) {
    SdPlatformNotificationEmbeddableFields["Receiver"] = "receiver";
    SdPlatformNotificationEmbeddableFields["User"] = "user";
    SdPlatformNotificationEmbeddableFields["Model"] = "model";
    SdPlatformNotificationEmbeddableFields["SavedState"] = "saved_state";
    SdPlatformNotificationEmbeddableFields["Document"] = "document";
    SdPlatformNotificationEmbeddableFields["Organization"] = "organization";
})(SdPlatformNotificationEmbeddableFields = exports.SdPlatformNotificationEmbeddableFields || (exports.SdPlatformNotificationEmbeddableFields = {}));
var SdPlatformNotificationSummaryEmbeddableFields;
(function (SdPlatformNotificationSummaryEmbeddableFields) {
    SdPlatformNotificationSummaryEmbeddableFields["Total"] = "total";
    SdPlatformNotificationSummaryEmbeddableFields["Unread"] = "unread";
})(SdPlatformNotificationSummaryEmbeddableFields = exports.SdPlatformNotificationSummaryEmbeddableFields || (exports.SdPlatformNotificationSummaryEmbeddableFields = {}));
/**
 * Operations for querying, reading/unreading, creating notifications.
 */
class SdPlatformNotificationApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "notifications";
    }
    /**
     * Query the notifications.
     * @param body {@link SdPlatformNotificationQueryParameters} notifications query body.
     * @returns the {@link SdPlatformQueryResponse} with {@link SdPlatformResponseNotification} as data result.
     */
    query(body = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.NotificationQuery, body);
    }
    /**
     * Creates the notification.
     * @param body {@link SdPlatformRequestNotificationCreate}
     * @returns the {@link SdPlatformPostResponse} with {@link SdPlatformResponseNotification} as result.
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.NotificationCreate, body);
    }
    /**
     * Creates the notification.
     * @param body {@link SdPlatformRequestNotificationCreate}
     * @returns the {@link SdPlatformPostResponse} with {@link SdPlatformResponseNotification} as result.
     */
    createMultiple(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.NotificationBatchCreate, ResourcesApi_1.Action.Post, 'batch', body);
    }
    /**
     * Updates the notification-
     * @param id - the id of a notification.
     * @param body {@link SdPlatformRequestNotificationPatch} body of a notification.
     * @returns the {@link SdPlatformPatchResponse} response with {@link SdPlatformResponseNotification} as result.
     */
    patch(id, body) {
        return this.__patch(SdPlatformRequestId_1.RequestId.NotificationPatch, id, body);
    }
    /**
     * Deletes the notification.
     * @param id - the id of a notification.
     * @returns  the {@link SdPlatformDeleteResponse}
     */
    delete(id) {
        return this.__delete(SdPlatformRequestId_1.RequestId.NotificationDelete, id);
    }
    /**
     * Gets the summary of notifications.
     * Gives information about total number of notifications and unread number of notifications.
     * @param embed - array of {@link SdPlatformNotificationSummaryEmbeddableFields} embed properties.
     * @returns the {@link SdPlatformGetResponse} response with {@link SdPlatformResponseNotificationSummary} as data.
     */
    summary(embed) {
        return super.__get(SdPlatformRequestId_1.RequestId.NotificationSummary, 'summary', embed);
    }
    /**
     * Gets the notification by id.
     * @param  id - the id of notification.
     * @returns the {@link SdPlatformGetResponse} with {@link SdPlatformResponseNotification} as data or one of it's derived classes.
     */
    get(id) {
        return super.__get(SdPlatformRequestId_1.RequestId.NotificationGet, id);
    }
    /**
     * Marks all notifications of signed in user as read.
     * @returns the {@link SdPlatformPostResponse} response.
     */
    markAllAsRead() {
        return super.__action(SdPlatformRequestId_1.RequestId.NotificationReadAll, ResourcesApi_1.Action.Post, 'read_all', {});
    }
}
exports.SdPlatformNotificationApi = SdPlatformNotificationApi;
//# sourceMappingURL=SdPlatformNotificationApi.js.map